export const STAGING_EDIT_ATTRIBUTES = Object.freeze({
  elementId: "data-staging-element-id",
  elementType: "data-staging-element-type",
  dynamicComponentId: "data-staging-dynamic-component-id",
});

export function stagingEditAttributes({ isStagingSurface, isProduction, elementId, elementType, dynamicComponentId }) {
  if (!isStagingSurface || isProduction) {
    return {};
  }
  return {
    [STAGING_EDIT_ATTRIBUTES.elementId]: String(elementId),
    [STAGING_EDIT_ATTRIBUTES.elementType]: String(elementType ?? ""),
    [STAGING_EDIT_ATTRIBUTES.dynamicComponentId]: String(dynamicComponentId),
  };
}

export function isStagingRenderSurface(clientData) {
  return Boolean(clientData?.stagingCompiledDescriptor);
}
